import axios, { type AxiosRequestConfig } from 'axios'

import { getXsrfTokenFromCookie } from '@dhl/receiver-axios'

import { i18n } from '../../i18n'
import { getConfig } from '~/config'
import { onOtcPath } from '~/paths'

type fetchOptions = {
  method: AxiosRequestConfig['method']
  url: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cancelToken?: any
}

export function fetchJson<T>(options: fetchOptions): Promise<T> {
  const { version } = getConfig()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fetchConfig: any = {
    url: options.url,
    method: options.method,
    data: options.data,
    headers: {
      'X-XSRF-TOKEN': getXsrfTokenFromCookie(),
      'X-LANG': i18n.language?.replace('-', '_'),
      'X-VERSION': version,
      'X-REQUESTED-WITH': onOtcPath() ? 'otc' : 'pwa',
    },
  }

  if (options.cancelToken) {
    const source = axios.CancelToken.source()

    fetchConfig.cancelToken = source.token

    const request = axios.request(fetchConfig)
    // @ts-expect-error
    request[options.cancelToken] = () => source.cancel()

    request.then((response) => response.data)
  }

  return axios
    .request<T>(fetchConfig)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}
